import { render, staticRenderFns } from "./PlusPay.vue?vue&type=template&id=1376aa27"
import script from "./PlusPay.vue?vue&type=script&lang=js"
export * from "./PlusPay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports